import { createContext, useState, useContext, useMemo } from 'react';

import { ProductsOfEventModes, useHomePageProductsOfEventModes } from '@/hooks/query';

interface HomePageContextType {
	isMainProductSelected: boolean;
	setIsMainProductSelected: (isMainProductSelected: boolean) => void;
	homePageProductsOfEventMode: ProductsOfEventModes;
}

const HomePageContext = createContext<HomePageContextType | undefined>(undefined);

export const HomePageProvider = ({ 
	children 
}: {
	children: React.ReactNode;
}) => {
	const [isMainProductSelected, setIsMainProductSelected] = useState(true);
	const homePageProductsOfEventMode = useHomePageProductsOfEventModes();
	
	const value = useMemo(() => ({
		isMainProductSelected,
		setIsMainProductSelected,
		homePageProductsOfEventMode
	}), [isMainProductSelected, homePageProductsOfEventMode]);

	return (
		<HomePageContext.Provider value={value}>
			{children}
		</HomePageContext.Provider>
	);
};

export const useHomePage = () => {
	const context = useContext(HomePageContext);

	if (context === undefined) {
		throw new Error('useHomePage must be used within a HomePageProvider');
	}

	return context;
};